import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TouchableOpacity } from "react-native";

import { Input, Picker } from "components";
import { useListQuestion } from "screens/question/hooks";

import { getOrganizationResponsibleUsers } from "state/modules/organization";

export const ListQuestion = ({ question }) => {
  const dispatch = useDispatch();
  const questionnaire_id = useSelector(state => state.survey.questionnaireId);

  useEffect(() => {
    dispatch(getOrganizationResponsibleUsers(questionnaire_id));
  }, [dispatch, questionnaire_id]);

  const {
    onPress,
    selectedOption,
    isPickerVisible,
    setPickerVisible,
    placeholder,
    options,
    RTL,
  } = useListQuestion(question);

  return (
    <TouchableOpacity onPress={() => setPickerVisible(true)} activeOpacity={1}>
      <Input
        value={selectedOption?.text.replaceAll("*", "") || ""}
        placeholder={placeholder}
        pointerEvents="none"
        fullscreen={false}
        editable={false}
        rtl={RTL}
      />
      <Picker
        visible={isPickerVisible}
        options={options}
        textKey="text"
        onPress={onPress}
        dismiss={() => setPickerVisible(false)}
      />
    </TouchableOpacity>
  );
};
